import { useEffect } from "react";
import { accessStorage } from "@chronosphereio/core";
import { PINNED_TIME_RANGE_ACTIVE_KEY, PINNED_TIME_RANGE_KEY } from "../../../plugin-system/runtime/TimeRangeProvider/index.js";
const useUnpinTimeRange = ()=>{
    useEffect(()=>{
        const { getItem: getPinnedTimeRange, setItem: setPinnedTimeRange } = accessStorage(window.localStorage, PINNED_TIME_RANGE_KEY);
        const pinnedTimeRange = getPinnedTimeRange();
        const pinnedTimeRangeActive = accessStorage(window.sessionStorage, PINNED_TIME_RANGE_ACTIVE_KEY).getItem();
        try {
            if (pinnedTimeRangeActive && pinnedTimeRange && pinnedTimeRange.backup && pinnedTimeRange.backup.tabCount > pinnedTimeRange.tabCount) setPinnedTimeRange({
                value: pinnedTimeRange.backup.value,
                tabCount: pinnedTimeRange.tabCount + 1,
                backup: {
                    value: pinnedTimeRange.backup.value,
                    tabCount: pinnedTimeRange.tabCount + 1
                }
            });
        } catch (_error) {}
        const handleBeforeUnload = ()=>{
            const { getItem: getPinnedTimeRange, setItem: setPinnedTimeRange } = accessStorage(window.localStorage, PINNED_TIME_RANGE_KEY);
            const pinnedTimeRange = getPinnedTimeRange();
            const pinnedTimeRangeActive = accessStorage(window.sessionStorage, PINNED_TIME_RANGE_ACTIVE_KEY).getItem();
            try {
                if (pinnedTimeRange && pinnedTimeRange?.tabCount > 0 && pinnedTimeRangeActive) setPinnedTimeRange({
                    ...pinnedTimeRange,
                    tabCount: Math.max(pinnedTimeRange.tabCount - 1, 0)
                });
            } catch (_error) {}
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);
};
export { useUnpinTimeRange };

//# sourceMappingURL=useUnpinTimeRange.js.map